import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSkipBackTen",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, r, p, _, a) {
  return l(), d("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--skip-back-ten"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Skip Back Ten",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.72 1.008a5 5 0 1 1-4.692 5.519.5.5 0 1 1 .994-.106 4 4 0 1 0 1.336-3.423l-.53.476H3a.5.5 0 0 1 0 1H1.5a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 1 1 1 0v.4l.695-.625a5 5 0 0 1 3.025-1.24Zm-.528 3.03A.5.5 0 0 1 5.5 4.5v3a.5.5 0 0 1-1 0V5.707l-.146.147a.5.5 0 0 1-.707-.707l1-1a.5.5 0 0 1 .545-.109ZM6 5.25a1.25 1.25 0 1 1 2.5 0v1.5a1.25 1.25 0 0 1-2.5 0v-1.5ZM7.25 5a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .5 0v-1.5A.25.25 0 0 0 7.25 5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=skip-back-ten.js.map
